module.exports = __webpack_public_path__ + "static/media/icon_mono_selected.f5a19e5f.svg";